/**
 * Column label-to-key lookup map for QuickFill table.
 * Replaces the switch statement in FilterableTable with a static map.
 */

type QuickFillKey = string;

const COLUMN_LABEL_TO_KEY: Record<string, QuickFillKey> = {
  'SKEY': 'SKEY',
  'OBJECT-TYPE': 'OBJECT-TYPE',
  'End1': 'End1',
  'End2': 'End2',
  'End3': 'End3',
  'End4': 'End4',
  'Piping Spec': 'PIPING-SPEC',
  'PIPING-SPEC': 'PIPING-SPEC',
  'System Grouping': 'SYSTEM-GROUPING',
  'SYSTEM-GROUPING': 'SYSTEM-GROUPING',
  'Material': 'MATERIAL',
  'MATERIAL': 'MATERIAL',
  'Design Standard': 'DESIGN-STD',
  'DESIGN-STD': 'DESIGN-STD',
  'Pressure Class': 'PRESSURE-CLASS',
  'PRESSURE-CLASS': 'PRESSURE-CLASS',
  'Insulation Spec': 'INSULATION-SPEC',
  'INSULATION-SPEC': 'INSULATION-SPEC',
  'Insulation Thickness': 'INSULATION-THICKNESS',
  'INSULATION-THICKNESS': 'INSULATION-THICKNESS',
  'Tracing Spec': 'TRACING-SPEC',
  'TRACING-SPEC': 'TRACING-SPEC',
  'Item Description': 'ITEM-DESCRIPTION',
  'ITEM-DESCRIPTION': 'ITEM-DESCRIPTION',
};

/**
 * Resolves a column label (possibly a display name) to the canonical data key.
 * Falls back to using the label itself if no mapping is found.
 */
export function resolveColumnKey(label: string): string {
  return COLUMN_LABEL_TO_KEY[label] ?? label;
}
